import React from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import PreviewBanner from "../PreviewBanner";
import Section from "../createNew/Section";
import { boxStyles } from "../../styles/theme";
import TabBar from "../createNew/TabBar";
import EditOptions from "./EditOptions";
import TitleWithBackButton from "../TitleWithBackButton";

const EditBodyDesktop = () => {
  return (
    <div className={container}>
      <TitleWithBackButton backLocation="home" title="Edit Spotlight" />
      <GenericCard style="card">
        <PreviewBanner />
        <div className="content">
          <Section heading="Spotlight Type">
            <TabBar />
          </Section>
          <EditOptions />
        </div>
      </GenericCard>
    </div>
  );
};

export default EditBodyDesktop;

const container = css`
  flex: 1;
  .card {
    width: 100%;
    flex-direction: column;
    .preview {
      background-color: royalblue;
    }
    .content {
      padding: ${boxStyles.desktopPadding};
    }
  }
`;
